import firebase from 'firebase/app'
import firestore from 'firebase/firebase-firestore'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCEdcHfwKG1HefPYI8Vgaock6ZuhDp3XLQ",
    authDomain: "ninja-chat-c4239.firebaseapp.com",
    databaseURL: "https://ninja-chat-c4239.firebaseio.com",
    projectId: "ninja-chat-c4239",
    storageBucket: "ninja-chat-c4239.appspot.com",
    messagingSenderId: "1094444181337"
};
const firebaseApp = firebase.initializeApp(config);

export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js